import 'reakit/styled';
import { theme } from 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import styled from '../styled/index.js';
import _Navigation from 'reakit/Navigation';
var Navigation = styled(_Navigation).withConfig({
  displayName: "styled__Navigation",
  componentId: "sc-1sfgrrm-0"
})(["", ";"], theme('fannypack.Navigation.base'));
export default Navigation;
export { Navigation };